import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap, combineReducers } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { RR_REC, ReferenceState } from '../reference-state';

export type ReferenceReducers = ReferenceState;

export function getReducers(): ActionReducerMap<ReferenceReducers> {
  return {
    RR: combineReducers({
      recomendationList: StateUtils.entityLoaderReducer(RR_REC),
    }),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<ReferenceReducers>> = new InjectionToken<
  ActionReducerMap<ReferenceReducers>
>('ReferenceReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
